import Vue from 'vue'
import {
  Button,
  Form,
  FormItem,
  Input,
  Checkbox,
  Select,
  Option,
  Switch,
  Tabs,
  TabPane,
  Message,
  MessageBox,
  Container,
  Header,
  Footer,
  Main,
  Carousel,
  CarouselItem,
  Image,
  Menu,
  MenuItem,
  MenuItemGroup,
  Submenu,
  Row,
  Col,
  Pagination,
  Dialog,
  Avatar,
  Upload,
  Tag,
  Popover,
  Drawer,
  Radio,
  RadioButton,
  RadioGroup,
  Notification,
  Breadcrumb,
  Backtop,
  InputNumber,
  CheckboxGroup,
  Table,
  TableColumn,
  DatePicker
} from 'element-ui'

Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Checkbox)
Vue.use(Select)
Vue.use(Option)
Vue.use(Switch)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Container)
Vue.use(Header)
Vue.use(Footer)
Vue.use(Main)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Image)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Submenu)
Vue.use(Row)
Vue.use(Col)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Avatar)
Vue.use(Upload)
Vue.use(Tag)
Vue.use(Popover)
Vue.use(Drawer)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Breadcrumb)
Vue.use(Backtop)
Vue.use(InputNumber)
Vue.use(CheckboxGroup)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(DatePicker)

Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;



// WEBPACK FOOTER //
// ./src/plugins/element.js